import { useAuthorSubscription } from '@/entities/author';
import { AuthorListCard } from '@/features/Author';
import { useTimedOpen } from '@/shared/hooks';
import { AuthorListCardProps } from '@/shared/types';

const AuthorListItem = ({
  id,
  name,
  imageUrl,
  isCompany,
  count,
  urlIdentifier,
  mostPublishedCategory,
  isSubscribed,
  description,
  tagLine,
  page,
}: AuthorListCardProps) => {
  const { mutate: subscribe } = useAuthorSubscription(page);
  const [isTooltipOpen, openTooltip] = useTimedOpen();

  const handleSubscribe = () => {
    subscribe(id);
    openTooltip();
  };

  return (
    <AuthorListCard
      id={id}
      name={name}
      imageUrl={imageUrl}
      isCompany={isCompany}
      count={count}
      urlIdentifier={urlIdentifier}
      mostPublishedCategory={mostPublishedCategory}
      isSubscribed={isSubscribed}
      description={description}
      tagLine={tagLine}
      onSubscribe={handleSubscribe}
      isTooltipOpen={isTooltipOpen}
    />
  );
};

export default AuthorListItem;
